var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["chapters-list", { mobile: _vm.isMobile(_vm.$mq) }] },
    _vm._l(_vm.chapters, function(chapter) {
      return _c(
        "div",
        {
          key: chapter.chapter_id,
          ref: "chapters",
          refInFor: true,
          staticClass: "chapter"
        },
        [
          _c("div", { staticClass: "header" }, [
            _c(
              "div",
              { staticClass: "image-container" },
              [
                chapter.quizzes.length &&
                chapter.quizzes.every(function(lesson) {
                  return lesson.user_state === "completed"
                })
                  ? _c("img", {
                      staticClass: "completed-check",
                      attrs: {
                        src:
                          "/site_media/version-0/images/course-page/completed-check.svg",
                        alt: "Green check"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("BriocheBackgroundImage", {
                  attrs: { src: chapter.image, width: 94 }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("h2", { staticClass: "title" }, [_vm._v(_vm._s(chapter.name))])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "lessons" },
            _vm._l(chapter.quizzes, function(lesson, index) {
              return _c("Lesson", {
                key: lesson.quiz_id,
                attrs: {
                  lesson: lesson,
                  "course-id": _vm.courseId,
                  "is-locked": chapter.show_paywall,
                  "is-recommended": _vm.recommendedSlug === lesson.slug,
                  "is-last": index === chapter.quizzes.length - 1,
                  "course-name": _vm.courseName
                }
              })
            }),
            1
          ),
          _vm._v(" "),
          !_vm.isMobile(_vm.$mq)
            ? _c("ChapterAdmin", {
                staticClass: "chapter-admin",
                attrs: {
                  chapter: chapter,
                  "course-version-name": _vm.courseVersionName
                }
              })
            : _vm._e()
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }